import React from "react";

const NoItemsRow = ({ name, div, as, className, ...props }) => {
	const TagName = as ? as : div ? "div" : "tr";

	const tagClassName = typeof className !== "undefined" ? className : div ? "col-xs-12" : undefined;

	const Children = (
		<>
			<div className="col-lg-5 col-xs-5">
				<div className="no-items"></div>
			</div>
			<div className="col-lg-2 col-xs-2">
				<h5 className="no-items">No {name}</h5>
			</div>
			<div className="col-lg-5 col-xs-5">
				<div className="no-items"></div>
			</div>
            <div className="clearfix"></div>
		</>
	);
	return <TagName className={tagClassName} {...props}>{Children}</TagName>;
};

export default NoItemsRow;
